
<app-header [logged]="isSessionActive" [webinarActivo]="webinarActivo"></app-header>

<div class="routerBox" [ngStyle]="webinarActivo ? {'margin-top' : '7rem'} : {}">
    <router-outlet></router-outlet>
</div>

<app-footer [logged]="isSessionActive"></app-footer>